import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: 
        0px 20px 50px -20px rgba(0, 0, 0, 0.1),
        0px 0px 40px 0px rgba(0, 0, 0, 0.1),
        0px 0px 50px 0px rgba(0, 0, 0, 0.05);
`;

const Card8 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props.backgroundColor || (props.content && props.content.backgroundColor);
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    // Find first text item index
    const firstTextIndex = items?.findIndex(item => item.__typename === "ContentfulRichText") ?? -1;

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            className={`card1 flex-1 flex justify-start ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {items && items.length > 0 && (
                <div className={`card8__content w-full`}>
                    {/* First text item with special styling */}
                    {firstTextIndex !== -1 && (
                        <div className="bg-gradient-card-header lg:px-[48px] lg:py-[32px] p-[24px] rounded-top_48">
                            <MapTo items={items[firstTextIndex]} />
                        </div>
                    )}

                    {/* Rest of the items */}
                    <div className="flex flex-col items-center lg:px-[40px] px-[24px] py-[32px]">
                        {items.map((item, index) => (
                            index !== firstTextIndex && (
                                <div key={item.id} className={`
                                    ${item.__typename === 'ContentfulMedia' ? 'max-w-[93px] w-full py-[16px] flex justify-center' : 'w-full'} 
                                    ${item.__typename === 'ContentfulRichText' ? 'p-0 [&_ul]:space-y-[8px] [&_ol]:space-y-[8px] lg:[&_ul]:space-y-[16px] lg:[&_ol]:space-y-[16px]' : ''}
                                `}>
                                    <MapTo items={item} className={item.__typename === 'ContentfulRichText' ? 'p-0' : ''} />
                                </div>
                            )
                        ))}
                    </div>
                </div>
            )}
        </StyledContainer>
    );
};

export default Card8; 